module.exports = "pegasus_template/assets/pets-logo.png";